import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { midas, colors } from '@resurs/midas'
import style from './button.style'

function capitalise(string) {
  if (string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }
  return string
}

export class Button extends PureComponent {
  buttonClassBuilder() {
    const {
      typeName,
      primaryColor,
      loading,
      size,
      inputGroup,
      buttonSmall,
    } = this.props
    let className = `${midas.button}`

    if (typeName) {
      className += ` ${midas[`button${capitalise(typeName)}`]}`
    }
    if (primaryColor) {
      className += ` ${midas[primaryColor]}`
    }
    if (loading) {
      className += ` ${midas.loading}`
    }
    if (size) {
      className += ` ${midas[`button${capitalise(size)}`]}`
    }
    if (inputGroup) {
      className += ` ${midas.inputGroupButton}`
    }
    if (buttonSmall) {
      className += ` ${midas.buttonSmall}`
    }

    return className
  }

  render() {
    const {
      text,
      icon,
      form,
      onClick,
      disabled,
      typeName,
    } = this.props

    let buttonForm = 'button'

    if (form) {
      buttonForm = 'submit'
    }

    return (
      <button
        className={this.buttonClassBuilder()}
        disabled={disabled}
        style={{ border: '1px dotted #f0f' }}
        type={buttonForm}
        onClick={e => onClick(e)}
      >
        <i
          className={` ${midas.icon} ${midas[icon]}`}
          style={{
            color: typeName !== 'link' ? style.white : colors.coreColor,
          }}
        />{' '}
        {text}
      </button>
    )
  }
}

Button.propTypes = {
  text: PropTypes.string,
  typeName: PropTypes.string,
  primaryColor: PropTypes.string,
  size: PropTypes.string,
  loading: PropTypes.bool,
  icon: PropTypes.string,
  form: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  inputGroup: PropTypes.bool,
  buttonSmall: PropTypes.bool,
}

Button.defaultProps = {
  text: '',
  typeName: '',
  primaryColor: '',
  size: '',
  loading: false,
  icon: '',
  form: false,
  disabled: false,
  dropdown: false,
  onClick: null,
  inputGroup: false,
  buttonSmall: false,
}
